import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import AppAnalyticsTracker from './components/globals/AppAnalyticsTracker';
import DevThemeToggle from './components/globals/DevThemeToggle';
import PageLoader from './components/globals/PageLoader';
import RouteProgressBar from './components/globals/RouteProgressBar';
import useUserProfile from './components/hooks/profile/useUserProfile';
import { AxiosProvider } from './contexts/AxiosContext';
import { PageLoaderProvider } from './contexts/PageLoaderContext';
import { shouldShowFloatingThemeSwitcher } from './utils/qaAppearance';

const QaFloatingThemeSwitcher = () => {
  const { profile } = useUserProfile();
  const isExtensionRuntime = typeof chrome !== 'undefined' && Boolean(chrome.runtime?.id);
  const isVisible = shouldShowFloatingThemeSwitcher({
    isDevelopment: import.meta.env.DEV,
    isExtensionRuntime,
    isQa: Boolean(profile?.user?.is_qa),
  });

  return isVisible ? <DevThemeToggle /> : null;
};

export default function AppWrapper() {
  return (
    <PageLoaderProvider>
      <AxiosProvider>
        <AppAnalyticsTracker />
        <RouteProgressBar />
        <Suspense fallback={<PageLoader open />}>
          <Outlet />
        </Suspense>
        <QaFloatingThemeSwitcher />
      </AxiosProvider>
    </PageLoaderProvider>
  );
}
